import { render, staticRenderFns } from "./RelatedBusinessesCard.vue?vue&type=template&id=1fe6a1c5&scoped=true&"
import script from "./RelatedBusinessesCard.vue?vue&type=script&lang=ts&"
export * from "./RelatedBusinessesCard.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedBusinessesCard.vue?vue&type=style&index=0&id=1fe6a1c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe6a1c5",
  null
  
)

export default component.exports